export const queryKeys = {
  orders: {
    all: ["orders"] as const,
    list: (filters?: object) => ["orders", "list", filters] as const,
    detail: (id: string) => ["orders", "detail", id] as const,
    funnelHealth: () => ["orders", "funnel-health"] as const,
    orderHealth: () => ["orders", "order-health"] as const,
  },
  users: {
    all: ["users"] as const,
    list: (filters?: object) => ["users", "list", filters] as const,
    detail: (id: string) => ["users", "detail", id] as const,
  },
  products: {
    all: ["products"] as const,
    list: (filters?: object) => ["products", "list", filters] as const,
    detail: (id: string) => ["products", "detail", id] as const,
  },
  coupons: {
    all: ["coupons"] as const,
    list: (filters?: object) => ["coupons", "list", filters] as const,
    detail: (id: string) => ["coupons", "detail", id] as const,
    health: (days: number) => ["coupons", "health", days] as const,
  },
  appEvents: {
    tripStats: (weeks: number) => ["app-events", "trip-stats", weeks] as const,
    newsletterPopupStats: (days: number) =>
      ["app-events", "newsletter-popup-stats", days] as const,
  },
  photoSizes: {
    all: ["photoSizes"] as const,
    list: () => ["photoSizes", "list"] as const,
    detail: (id: string) => ["photoSizes", "detail", id] as const,
  },
  bannerMessages: {
    all: ["bannerMessages"] as const,
    list: () => ["bannerMessages", "list"] as const,
    detail: (id: string) => ["bannerMessages", "detail", id] as const,
  },
  productTags: {
    all: ["productTags"] as const,
    list: () => ["productTags", "list"] as const,
    detail: (id: string) => ["productTags", "detail", id] as const,
  },
  invoices: {
    all: ["invoices"] as const,
    list: (filters?: object) => ["invoices", "list", filters] as const,
    detail: (id: string) => ["invoices", "detail", id] as const,
  },
  posts: {
    all: ["posts"] as const,
    list: (filters?: object) => ["posts", "list", filters] as const,
    detail: (id: string) => ["posts", "detail", id] as const,
  },
  productWithMediaDefinitions: {
    all: ["productWithMediaDefinitions"] as const,
    list: (filters?: object) => ["productWithMediaDefinitions", "list", filters] as const,
    detail: (id: string) => ["productWithMediaDefinitions", "detail", id] as const,
  },
  productWithMediaVariants: {
    all: ["productWithMediaVariants"] as const,
    list: (definitionId: string) =>
      ["productWithMediaVariants", "list", definitionId] as const,
  },
  pricing: {
    all: ["pricing"] as const,
    bootstrap: () => ["pricing", "bootstrap"] as const,
    history: (limit: number) => ["pricing", "history", limit] as const,
  },
  papers: {
    all: ["papers"] as const,
    list: (filters?: object) => ["papers", "list", filters] as const,
    detail: (id: string) => ["papers", "detail", id] as const,
  },
  elementImages: (category?: string) => ['element-images', category ?? 'all'] as const,
  elementImageLibrary: (params?: { category?: string; type?: string; search?: string }) =>
    ['element-image-library', params?.category ?? null, params?.type ?? null, params?.search ?? null] as const,
};
